import { DatePipe } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

import { RegisterData } from '../resolvers/register.resolver';
import { ACCEPTED_FORMATS, getShortDateFormat } from './date-utils';
import { getCurrentRegisterLocale, TypedActivatedRoute } from './route-utils';

@Injectable({
  providedIn: 'root',
})
export class AADateParserFormatter extends NgbDateParserFormatter {
  datePipe = new DatePipe('en-US');

  constructor(
    @Inject(ActivatedRoute)
    private route: TypedActivatedRoute<{}, RegisterData> | null = null,
  ) {
    super();
  }

  format(date: NgbDateStruct): string {
    if (date === null) {
      return '';
    }

    const dateFormat = getShortDateFormat(getCurrentRegisterLocale(this.route?.snapshot));

    try {
      return (
        this.datePipe.transform(new Date(date.year, date.month - 1, date.day), dateFormat) || ''
      );
    } catch (e) {
      return '';
    }
  }

  parse(value: string): NgbDateStruct {
    const dateFormat = getShortDateFormat(getCurrentRegisterLocale(this.route?.snapshot));

    const formats = [...AADateParserFormatter.getMomentFormats(dateFormat), ...ACCEPTED_FORMATS];

    const m = moment(value, formats, true);

    if (m.isValid()) {
      return {
        day: m.date(),
        month: m.month() + 1,
        year: m.year(),
      };
    }

    return { year: 0, month: 0, day: 0 };
  }

  static getMomentFormats(dateFormat: string) {
    dateFormat = dateFormat.toUpperCase();
    return [
      dateFormat,
      // e.g. DD/MM/YY
      dateFormat.replace(/(YY)\1/, '$1'),
      // e.g. D/M/YYYY
      dateFormat.replace(/([DM])\1/g, '$1'),
      // e.g. D/M/YY
      dateFormat.replace(/([DM]|YY)\1/g, '$1'),
    ];
  }
}
